
import { FailureType ,IADPState} from "../typings";
import { ErrorButtons, ErrorPropsV2, Failure as Error, Wait,SplitLayout } from "@npd-ng/adp-component-library";
import { useDispatch, useSelector } from "react-redux";
import { createSetExitAction, createTryAgainAction } from "../state/reducer";
import errorTriangle from '../assets/red_triangle_exclamation.svg'
import { useState } from "react";
export default function RunningProccessFailureView() {
  const state = useSelector((state:{rootState:IADPState})=>state.rootState)
  const dispatch = useDispatch()
  const content = useSelector((state:{rootState:IADPState})=>state.rootState.currentLanguageContent)
  const errorContent = useSelector((state:{rootState:IADPState})=>state.rootState.currentLanguageContent?.error.ProccessCheckError)
  let contentList:string[] = []
  if(errorContent?.content){
    errorContent.content.forEach((element:string)=>{
      contentList.push(element)
    })
  }

    const checkResults = state.deviceReadinessState.deviceReadinessInfo?.failureReason.filter((failure)=>failure.name==="checkRunningProcesses")
    if(checkResults && checkResults.length>0){
        checkResults[0].value?.forEach((element:string) => {
          contentList.push(`<p style="color:#ff5733">${element}</p>`)
        });
    }
  const handleExit = () =>{
    dispatch(createSetExitAction());
  } 
  const errorProps:ErrorPropsV2 ={
    iconSrc:errorTriangle,
    title:errorContent?.title || "",
    content:contentList,
    buttons:[
        {
            label: content?.actions.exit || "Exit Application",
            action: handleExit,
            variant: "secondary",
            key:0
        }
    ],
    errorCode:errorContent?.errorCode,
    alt:state.currentLanguageContent?.imageAltText.failureTriangleIcon as string

  }
  return (
    <SplitLayout logoAlt={state.currentLanguageContent?.imageAltText.naepLogo as string}>
        <Error {...errorProps}/>
    </SplitLayout>
  )       
}
